import { Icon } from '@chakra-ui/icons'
import { IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const MoonCloudIcon: FC<IconProps> = (props) => (
  <Icon xmlSpace="preserve" viewBox="0 0 45 40" boxSize="32px" {...props}>
    <path
      d="M10.5 21.5c-2.3 0-4.4.8-6 2.5C2.8 25.7 2 27.7 2 30c0 2.4.8 4.4 2.5 6 1.6 1.6 3.7 2.5 6 2.5h8.9c1.5 0 2.8-.5 3.9-1.6 1.1-1 1.6-2.4 1.6-3.9 0-1.6-.6-3-1.8-4.1-1-.9-2.4-1.4-3.8-1.4h-.8l-.4-.9c-.7-1.5-1.7-2.8-3.1-3.7-1.4-.9-2.9-1.4-4.5-1.4zm-4.6.4c0-.3-.1-.6-.1-.8v-.9c0-4.6 1.4-8.5 4.4-12 2.3-2.7 5.3-4.8 9-6-.2 2.8.1 5.5.9 8.1 1 3.4 2.8 6.4 5.4 9 2.5 2.6 5.6 4.4 9 5.4 2.2.7 4.5 1 6.7 1h1.4l-.3 1c-1.1 3.1-2.9 5.8-5.6 8-3.5 2.9-12.3 3.9-16.9 3.9"
      style={{
        fill: 'none',
        stroke: '#0b2730',
        strokeWidth: 3,
        strokeMiterlimit: 2
      }}
    />
  </Icon>
)
export default MoonCloudIcon
